<template>
  <a-modal
    title="导入替换原料"
    :visible="hidden"
    @ok="ok" 
    :bodyStyle="{padding:'10px'}"
    :destroyOnClose="false"
    @cancel="cancel"
    width="900px"
  >
      <a-row style="padding:0 0 10px" type="flex" align="middle" justify="space-between">
        <a-col>
          <a-input-search size="small" v-model="filterData.name" @change="e => inputChange(e,'name')" placeholder="原料名称/代码" style="width: 180px;margin-right: 10px;" @search="e => onSearch(e,'name')" />
          <a-input-search v-if="overseasFlag==1" size="small" v-model="filterData.aliasName" @change="e => inputChange(e,'aliasName')" placeholder="原料别名" style="width: 180px" @search="e => onSearch(e,'aliasName')" />
        </a-col>
        <type-list v-model="filterData.typeId" category="raw" @setVal='setVal' placeholder="请选择原料类型" />
      </a-row>
      <a-table
        row-key="rawId"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :row-selection="rowSelection"
        :scroll="{y: 350}"
        bordered
      >
        <template slot="name" slot-scope="text,record">
            {{overseasFlag == '1' ? (record.aliasName || text) : text}}
          </template>
          <template slot="fixed3" slot-scope="t">{{ t || t === 0 ? Number(t).toFixed(3) : t }}</template>
      </a-table>
      <a-row slot="footer" type="flex" justify="space-between" class="footer">
        <span>
          <span style="font-size:12px"  v-if="selectedRows.length">
          已选中 {{selectedRows.length}}条原料
          </span>
        </span>
        <a-space>
          <a-button @click="cancel">取消</a-button>
          <a-button @click="ok" type="primary">保存</a-button>
        </a-space>
      </a-row>
  </a-modal>
</template>

<script>
import TypeList from '@/components/Common/components/Type.vue'
export default {
  props:['hidden','selectKeys'],
  components: {TypeList},
  data(){
    return{
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      filterData:{typeId: undefined,aliasName: undefined,name: undefined},
      list: [],
      rawType: [],
      columns:[
        { 
          dataIndex:'name',
          title: '原料名称',
          width:300,
          scopedSlots: {customRender: 'name'},
        },
        {
          dataIndex:'code',
          align:'center',
          title: '代码',
          width:110,
          scopedSlots: {customRender: 'code'},
        },
        {
          dataIndex:'rawTypeName',
          title: '类型',
        },
        {
          dataIndex:'storageWeight',
          title: '库存量',
          scopedSlots: {customRender: 'fixed3'},
          align: 'center',
        },
        {
          dataIndex:'unit',
          title: '单位',
          align:'center',
        },
      ],
      pagination: {
        total:0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        showTotal: (total) => `总共${total}个原料`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      selectedRowKeys: [],
      selectedRows: [],
      timer: null
    }
  },
  computed: {
    rowSelection() {
      return {
        type: 'radio',
        selectedRowKeys:this.selectedRowKeys,
        onChange: (selectedRowKeys,selectedRows) => {
          // selectKeys
          if(selectedRowKeys.length > 0 && this.selectKeys.includes(selectedRowKeys[0])){
            this.selectedRowKeys = []
            this.selectedRows = []
            this.$error({
              title: '操作失败',
              content: `${selectedRows[0].name}已经添加到配方中，请调整后再提交`,
            });
          }else{
            this.selectedRowKeys = selectedRowKeys
            let arr = [...this.selectedRows, ...selectedRows]
            this.selectedRows = selectedRowKeys.map(i => {
              return arr.filter(item=>item.rawId === i)[0]
            })
          }
        },
      }
    },
  },
  mounted(){
    // this.getList(this.pagination)
  },
  watch:{
    hidden(val){
      if(val) {
        this.filterData = {typeId: undefined,aliasName: undefined,name: undefined}
        this.selectedRowKeys = []
        this.selectedRows = []
        this.rawType = []
        this.getList({current: 1,pageSize: 100})
      }
    }
  },
  methods:{
    inputChange({target},feild){
      if(!this.timer)
      this.timer = setTimeout(() => {
        this.filterData[feild] = target.value
        let {current=1,pageSize=100} = this.pagination || {}
        this.getList({current,size: pageSize})
        this.timer = null
      }, 300);
    },

    ok(){
      if(this.selectedRows.length){
        this.$emit('ok',this.selectedRows[0])
      }else{
        this.$message.warn('选择需要添加的原料')
      }
    },
    
    cancel(){
      this.$emit('cancel')
    },

    getList(pagination){
      let {current=1,pageSize=100} = pagination || this.pagination
      let factoryId = window.localStorage.getItem('factoryId')
      let params = {current,size:pageSize,factoryId,...this.filterData}
      this.$http.get('/nhf-app/factorystaffraw/myRawpage',{params}).then(res => {
        let {success,data} = res || {}
        if(success){
          let {records,current=1,total=0} = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
        }
      })
    },

    onSearch(name,feild){
      let {pageSize=100} = this.pagination || {}
      this.getList({[feild]:name,current: 1,pageSize})
    },
    setVal(val){
      if(val) {
        this.filterData.typeId = val ? val[val.length - 1] : undefined
      }else{
        this.filterData.typeId = undefined
      }
      let {pageSize=100} = this.pagination || {}
      this.getList({current: 1,pageSize})
    },
  }
}
</script>
<style lang="scss" scoped>
  .footer{
    padding:10px 15px 0;
    margin:10px -10px 0;
    border-top:1px solid #eee;
  }
</style>
